import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "/booking-meeting-room-equipment";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  room_meeting_type?: string;
};

export interface BookingMeetingRoomEquipmentListType extends pagination_list {
  id_meeting_room?: number;
  id_room_meeting?: number;

}

export type equipment_booking_data = {
  id_meeting_room: number;
  id_room_meeting: number;
  id_equipment: number;
  qty: number;
  status: string;
  meeting_room_equipment_type: "BASE" | "ADD_NEW"
}


export class BookingMeetingRoomEquipmentApi extends BaseAPI {
  static createEquipmentToMeetingRoom(body: any): Promise<any> {
    return this.api.post(`${path}/meeting-room-equipment`, body);
  }

  static updateEquipmentInMeetingRoom(
    id_meeting_room: number,
    body: any
  ): Promise<any> {
    return this.api.patch(`${path}/meeting-room-equipment/${id_meeting_room}`, body);
  }

  static deleteEquipmentImMeetingRoomById(id: number): Promise<any> {
    return this.api.delete(`${path}/meeting-room-equipment/${id}`);
  }


  static listEquipment(params: BookingMeetingRoomEquipmentListType): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, { params })
  }

  static createUpdateBookingEquipment(id_meeting_room: number, body: equipment_booking_data[]): Promise<AxiosResponse> {
    return this.api.put(`${path}/meeting-room/${id_meeting_room}`, body)
  }
  static deleteBookingEquipment(id_room_meeting_equipment: number): Promise<AxiosResponse> {
    return this.api.delete(`${path}/meeting-room-equipment/${id_room_meeting_equipment}`)
  }

}
